import {
  ArgumentError,
  InvalidInputError,
  UnknownApiError,
} from './errors';

export default function (api) {
  /**
   * @memberof API
   * @instance
   */
  const schedule = {
    /**
     * Retrieve the current, previous and next program for a channel.
     * Auth token is not required.
     *
     * @method
     * @this API
     *
     * @param {Object} payload
     * @param {string} payload.channelId
     *
     * @return {Promise} promise
     * @fulfill {CurrentChannelSchedule}
     * @reject {ArgumentError} Channel ID is required
     * @reject {InvalidInputError} Channel cannot be found
     * @reject {UnknownApiError} Server returned with unexpected status code
    */
    getCurrent: function getCurrent(payload = {}) {
      if (typeof payload.channelId === 'undefined' || typeof payload.channelId !== 'string') {
        return Promise.reject(new ArgumentError('payload.channelId is required and must be a string'));
      }

      return this.request('get', `/schedule/v1/livestreams/${payload.channelId}/live`)
        .then((res) => {
          switch (res.status) {
            case 200: {
              return res.body;
            }
            case 404: {
              throw new InvalidInputError('Channel not found', res);
            }
            default: {
              throw new UnknownApiError('server returned with unhandled status code', res);
            }
          }
        });
    }.bind(api),
  };

  return schedule;
}
